import React, { useMemo, useState } from 'react';
import { COLOR_BY_NUMBER } from '../../enums/colorByNumber';
import { BetType } from '../../enums/tableNumbers';
import { isMobile } from '@pascal/pascal-core';
import { useIdsGenerator } from '../../hooks/useIdsGenerator';
import { doChipStore } from '../../store/doChipStore';

export const StatisticNumbersWrapper = ({ selectedData, statistics, onMouseMove = () => {}, onMouseLeave = () => {} }) => {
  const [activeNumberColumns, setActiveNumberColumns] = useState(null);
  const [activeNumberTitle, setActiveNumberTitle] = useState(null);
  const { neighbors } = doChipStore;

  const numbersTitle = useMemo(() => {
    setActiveNumberTitle(null);
    return statistics.numbersStatistics.slice(0, 8);
  }, [statistics]);

  const numbersColumns = useMemo(() => {
    setActiveNumberColumns(null);
    return statistics.numbersStatistics.slice(8);
  }, [statistics]);

  const numbersColumnsKeys = useIdsGenerator(numbersColumns, []);
  const numbersColumnsTitleKeys = useIdsGenerator(numbersTitle, []);

  const isActiveOvalBlock = (item) => {
    if (selectedData?.includes(item)) {
      if (selectedData?.length === 1) {
        return true;
      }
      return !!(selectedData?.includes('neighbors') || selectedData?.includes('OvalCombinationBets'));
    }
  };

  return (
    <div className='numbers-wrp' onMouseMove={(e) => onMouseMove(e, neighbors)}
         onMouseLeave={onMouseLeave}>
      <div className='numbers-title-wrp'>
        {numbersTitle.map((number, index) => {
          return (
            <span
              onClick={() => setActiveNumberTitle(index)}
              data={BetType[`StraightUp_${number}`]}
              className={`${
                isActiveOvalBlock(number) ? 'active' : ''
              } ${ activeNumberTitle === index && isMobile() ? 'active' : ''} ${
                COLOR_BY_NUMBER[number].color
              }`}
              key={numbersColumnsTitleKeys[index]}
            >
              {number}
            </span>
          );
        })}
      </div>
      <div className='numbers-main-wrp'>
        {numbersColumns.map((number, index) => {
          return (
            <div
              onClick={() => setActiveNumberColumns(index)}
              data={BetType[`StraightUp_${number}`]}
              className={`${
                isActiveOvalBlock(number) ? 'active' : ''
              } ${ activeNumberColumns === index && isMobile() ? 'active' : ''} number-box ${
                COLOR_BY_NUMBER[number].color
              }`}
              key={numbersColumnsKeys[index]}
            >
              {number}
            </div>
          );
        })}
      </div>
    </div>
  );
};
